// FT-186 REQ-04: если для брони есть снимок, восстановленный после убитого Android-приложения,
// карточка сама открывает диалог фото — загрузчик заберёт снимок при монтировании.
// Миксином, а не правкой BookingCard: условие проверяется спекой без монтирования карточки.
import { hasRestoredCaptureFor } from "@/services/nativeCamera";

export default {
  watch: {
    "booking.id": {
      immediate: true,
      handler(id) {
        if (id && hasRestoredCaptureFor(id)) this.uploadPhotosDialog = true;
      },
    },
  },
};
